import LoadingButton from "@mui/lab/LoadingButton"
import {
  Box,
  Button,
  Fab,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import { TailSpin } from "react-loader-spinner"
import { DeleteIcon } from "../SVGs"
import { Colors } from "../Theme/colors"
import { Fonts } from "../Theme/font"

export const StyledFab = styled(Fab)({
  margin: 0,
  position: "absolute",
  top: 15,
  right: 15,
  color: Colors.secondary,
  width: 40,
  height: 40,
  backgroundColor: Colors.light,
  cursor: "pointer",
  boxShadow: `0px 2px 0px 0px ${Colors.primaryDarkest}`,
  "&:hover": { backgroundColor: Colors.offwhite, color: Colors.primaryDarkest },
  "&:focused": {
    backgroundColor: Colors.offwhite,
    color: Colors.primaryDarkest,
  },
})

export const StyledMenuItem = styled(MenuItem)({
  background: Colors.light,
  borderRadius: "5px",
  width: "100%",
  "&:hover": {
    background: Colors.offwhite,
  },
})
export const ButtonsRow = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 12,
})
export const StyledDeleteMenuItem = styled(MenuItem)({
  background: Colors.deleteprimaryDarkest,
  borderRadius: "5px",
  padding: "8px 12px",
  cursor: "pointer",
  width: "100%",
  "&:hover": {
    backgroundColor: Colors.deleteprimaryDarker,
  },
})
export const StyledNormalButton = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  font: `normal normal normal 700 16px/24px ${Fonts.primary}`,
  padding: "8px 12px",
  flexShrink: 0,
  width: "100%",
  transition: "all 0.3s ease-in-out",
  borderRadius: 8,
  border: `1px solid ${Colors.primaryDarkest}`,
  background: Colors.primaryDarkest,
  color: Colors.buttonText,
  cursor: "pointer",
  boxShadow: "none",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: Colors.primaryDarker,
    borderColor: `${Colors.primaryDarker}`,
  },
  "&:focus": {
    backgroundColor: Colors.primaryDarkest,
    borderColor: `${Colors.primaryDarkest}`,
  },
  "&.Mui-disabled": {
    backgroundColor: Colors.primaryDarkest,
    borderColor: `${Colors.primaryDarkest}`,
    opacity: 0.5,
    color: Colors.buttonText,
  },
})
export const StyledButton = styled(LoadingButton)({
  alignItems: "center",
  font: `normal normal normal 700 16px/24px ${Fonts.primary}`,
  padding: "12px 8px",
  gap: 10,
  flexShrink: 0,
  width: "100%",
  height: 48,
  transition: "all 0.3s ease-in-out",
  borderRadius: 8,
  border: `1px solid ${Colors.primaryDarkest}`,
  color: Colors.buttonText,
  cursor: "pointer",
  boxShadow: "none",
  textTransform: "capitalize",
  "&.MuiLoadingButton-root": {
    backgroundColor: Colors.primaryDarkest,
    color: Colors.buttonText,
  },
  "&:hover": {
    backgroundColor: Colors.primaryDarker,
    borderColor: `${Colors.primaryDarker}`,
  },
  "&:focus": {
    backgroundColor: Colors.primaryDarkest,
    borderColor: `${Colors.primaryDarkest}`,
  },
  "&.Mui-disabled": {
    backgroundColor: Colors.primaryDarkest,
    borderColor: `${Colors.primaryDarkest}`,
    opacity: 0.5,
  },
})
export const StyledDeleteButton = styled(LoadingButton)({
  alignItems: "center",
  justifyContent: "flex-start",
  font: `normal normal normal 500 18px/24px ${Fonts.primary}`,
  padding: "12.8px 18px",
  gap: 10.8,
  flexShrink: 0,
  width: "100%",
  height: 48,
  transition: "all 0.3s ease-in-out",
  borderRadius: 8,
  border: `1px solid ${Fonts.primary}`,
  color: Colors.buttonText,
  cursor: "pointer",
  boxShadow: "none",
  backgroundColor: Colors.deletePrimary,
  textTransform: "capitalize",
  "&.MuiLoadingButton-root": {
    backgroundColor: Colors.deleteprimaryDarkest,
    color: Colors.buttonText,
  },
  "&:hover": {
    backgroundColor: Colors.deleteprimaryDarker,
    borderColor: `${Colors.deleteprimaryDarker}`,
  },
  "&:focus": {
    backgroundColor: Colors.deleteprimaryDarkest,
    borderColor: `${Colors.deleteprimaryDarkest}`,
  },
  "&.Mui-disabled": {
    backgroundColor: Colors.deletePrimary,
    borderColor: `${Colors.deletePrimary}`,
    opacity: 0.5,
  },
})
export function CustomFab({ icon, ...rest }) {
  return (
    <StyledFab {...rest} disableTouchRipple disableRipple>
      {icon}
    </StyledFab>
  )
}
export function CustomNormalButton({
  className,
  loading,
  text,
  loadingText,
  ...rest
}) {
  return (
    <StyledNormalButton
      className={className}
      {...rest}
      disableTouchRipple
      disableRipple
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <span>{loadingText ? loadingText : ""}</span>
          <TailSpin
            height="30"
            width="30"
            color={Colors.buttonText}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      ) : (
        text
      )}
    </StyledNormalButton>
  )
}
export function CustomMenuItemButton({
  onClick,
  text,
  icon,
  loading,
  loadingText,
  className,
  ...rest
}) {
  return (
    <StyledMenuItem
      className={className}
      {...rest}
      disableTouchRipple
      disableRipple
      onClick={onClick}
    >
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText
        primaryTypographyProps={{
          fontFamily: Fonts.primary,
          color: Colors.secondary,
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
        }}
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <span>{loadingText ? loadingText : ""}</span>
            <TailSpin
              height="30"
              width="30"
              color={Colors.secondary}
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          text
        )}
      </ListItemText>
    </StyledMenuItem>
  )
}
export function CustomDeleteButton({ text, icon, ...rest }) {
  return (
    <StyledDeleteMenuItem {...rest} disableTouchRipple disableRipple>
      <ListItemIcon sx={{ color: Colors.light }}>
        <DeleteIcon />
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          fontFamily: Fonts.primary,
          color: Colors.light,
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
          textTransform: "capitalize",
        }}
      >
        {text}
      </ListItemText>
    </StyledDeleteMenuItem>
  )
}
export function SubmitButton({ type = "submit", loading, text, ...rest }) {
  return (
    <StyledButton
      {...rest}
      loading={loading}
      type={type}
      loadingIndicator={
        loading && (
          <TailSpin
            height="30"
            width="30"
            color={Colors.buttonText}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        )
      }
    >
      <span>{!loading && text}</span>
    </StyledButton>
  )
}
export function DownloadButton({ loading, text, ...rest }) {
  return (
    <StyledButton
      {...rest}
      loading={loading}
      type="button"
      loadingIndicator={
        loading && (
          <TailSpin
            height="30"
            width="30"
            color={Colors.buttonText}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        )
      }
    >
      <span>{!loading && text}</span>
    </StyledButton>
  )
}
export function DeleteButton({ loading, text, ...rest }) {
  return (
    <StyledDeleteButton
      loading={loading}
      loadingIndicator={
        loading && (
          <TailSpin
            height="25"
            width="25"
            color={Colors.buttonText}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        )
      }
      {...rest}
    >
      <span>{!loading && text}</span>
    </StyledDeleteButton>
  )
}
